import axios from 'axios';
import { API_ENDPOINTS, customToast, route, Variants } from 'carrier-fe';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

function RegisterId() {
	const { registrationId } = useParams();
	const navigate = useNavigate();

	const [searchParams] = useSearchParams();
	const campaign = searchParams.get('campaign');

	const [stage, setStage] = useState('');
	const [isFetching, setIsFetching] = useState(false);

	useEffect(() => {
		const fetchStage = async () => {
			if (!registrationId || isFetching) return;
			setIsFetching(true);

			try {
				const res = await axios.get(
					route(API_ENDPOINTS.REGISTRATION.VIEW, {
						registrationId: registrationId || '',
					})
				);
				setStage(res?.data?.data?.stage);
			} catch (error: any) {
				customToast({
					variant: Variants.Danger,
					title:
						error?.response?.data?.message ||
						'Something went wrong...',
				});
			} finally {
				setIsFetching(false);
			}
		}
		
		fetchStage();
	}, [registrationId]);

	const storeCampaign = async () => {
		try {
			await axios.patch(
				route(API_ENDPOINTS.REGISTRATION.STEP_ONE, {
					registrationId: registrationId || '',
				}),
				{ campaign }
			);
		} catch (error: any) {
			customToast({
				variant: Variants.Danger,
				title:
					error?.response?.data?.message ||
					'Something went wrong...',
			});
		}
	};

	useEffect(() => {
		const redirectToNextStage = async () => {
			if (!stage || stage === '') return;
	
			const routeMap: Record<string, string> = {
				'step-one': 'overview',
				'step-two': 'system-selection',
				'step-three': 'system-specific',
				'step-four': 'user-details',
				'step-five': 'company-details',
				'step-six': 'complete',
			};
		
			const path = routeMap[stage];
			if (!path) return;

			if (stage === 'step-one' && campaign) {
				await storeCampaign();
				navigate(`/register/${registrationId}/system-selection`);
			} else {
				navigate(`/register/${registrationId}/${path}`);
			}
		}

		redirectToNextStage();
	}, [stage, registrationId, campaign, navigate]);

	return <></>;
}

export default RegisterId;
